import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appNumbersOnly]'
})
export class NumbersOnlyDirective {
  private inputElement: HTMLElement;
  private NON_DIGITS_KEYS: RegExp = /\D/g;

  constructor(public el: ElementRef) {
    this.inputElement = el.nativeElement;
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(e: KeyboardEvent): void {
    if (this.isNavigationKey(e) || this.isMacShortcutKey(e) || this.isWindowsShortcutKey(e)) {
      return;
    }

    const key: number = parseInt(e.key, 10);
    const isNotNumbers: boolean = !(key >= 0) && !(key <= 9);

    if (isNotNumbers) {
      e.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(e: ClipboardEvent): void {
    try {
      e.preventDefault();
      this.inputElement.focus();

      const isIE: boolean = !e.clipboardData;
      const clipboardData: any = isIE ? window['clipboardData'].getData('Text') : e.clipboardData.getData('text/plain');
      const pastedInput: string = clipboardData.replace(this.NON_DIGITS_KEYS, '');

      if (isIE) {
        document.execCommand('paste', false, pastedInput);
      } else {
        document.execCommand('insertText', false, pastedInput);
      }
    } catch (_) {}
  }

  @HostListener('drop', ['$event'])
  onDrop(e: DragEvent): void {
    try {
      e.preventDefault();

      this.inputElement.focus();
      document.execCommand('insertText', false, e.dataTransfer.getData('text').replace(this.NON_DIGITS_KEYS, ''));
    } catch (_) {}
  }

  private isNavigationKey(e: KeyboardEvent): boolean {
    return (
      ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'Home', 'End', 'ArrowLeft', 'ArrowRight', 'Clear', 'Copy', 'Paste'].indexOf(e.key) >
      -1
    );
  }

  private isMacShortcutKey(e: KeyboardEvent): boolean {
    return (
      (e.key === 'a' && e.metaKey === true) || // Allow: Cmd+A (Mac)
      (e.key === 'c' && e.metaKey === true) || // Allow: Cmd+C (Mac)
      (e.key === 'v' && e.metaKey === true) || // Allow: Cmd+V (Mac)
      (e.key === 'x' && e.metaKey === true) // Allow: Cmd+X (Mac)
    );
  }

  private isWindowsShortcutKey(e: KeyboardEvent): boolean {
    return (
      (e.key === 'a' && e.ctrlKey === true) || // Allow: Ctrl+A
      (e.key === 'c' && e.ctrlKey === true) || // Allow: Ctrl+C
      (e.key === 'v' && e.ctrlKey === true) || // Allow: Ctrl+V
      (e.key === 'x' && e.ctrlKey === true) // Allow: Ctrl+X
    );
  }
}
